import * as angular from 'angular';

import { MixableBaseController } from '../../common/component';
import {
  generateFormatFromFlatTableFormat,
  convertColFromDatasetToFlamingo,
  getDefaultFieldFormatMapFromColumns,
  getDefaultGeneralFormat,
  getDefaultTableColumnSettingsFromColumns,
} from '@mode/shared/util-js';
import { Dataset } from '@mode/legacy/data-access-model-js';
import { ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';

class DatasetGridController {
  // bindings
  private dataset: Dataset;

  // local state
  private content: Dataset['content'];
  private columns: FlamingoTypes.RecordsResult['columns']; // converted to flamingo columns
  private format: ChartTypes.ChartFormat;
  private fieldFormats: ChartTypes.FieldFormatMap;

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.dataset && changes.dataset.currentValue != null) {
      // transform columns
      this.columns = this.dataset.columns.map((column) => convertColFromDatasetToFlamingo(column));
      this.content = this.dataset.content;

      // Generate the formats
      let general = getDefaultGeneralFormat(ChartTypes.FlatTableDefaultGeneralFormat.Results);
      general = {
        ...general,
        sizingStyle: 'sizeToFit',
      };
      this.format = generateFormatFromFlatTableFormat({
        general,
        columns: getDefaultTableColumnSettingsFromColumns(this.columns),
      });
      this.fieldFormats = getDefaultFieldFormatMapFromColumns(this.columns);
    }
  }
}

export const DatasetGridComponent: angular.IComponentOptions = {
  bindings: {
    dataset: '<',
  },
  controllerAs: 'ctrl',
  controller: DatasetGridController,
  template: `
  <div ng-if="ctrl.dataset" class="dataset-grid-container">
    <mode-flat-table-ng
      ng-if="ctrl.dataset.count > 0"
      [columns]="ctrl.columns"
      [content]="ctrl.content"
      [format]="ctrl.format"
      [field-formats]="ctrl.fieldFormats"
      [expandable-cell-contents]="true"
      [token]="ctrl.dataset.query_token"
    ></mode-flat-table-ng>
    <div class="no-results" ng-if="ctrl.dataset.count === 0">
      <span class="icon icon-no-results"></span>
      <h2>Looks like your query didn't return any results</h2>
      <div class="edit-query">
        <h3>Try broadening your query.</h3>
      </div>
    </div>
  </div>
  `,
};
